import React, { useRef, useState } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import { Table } from '@rd-web-markets/shared/dist/util';
import { useTechnicalTemplateImportStatus } from '@rd-web-markets/shared/dist/hooks/useTechnicalTemplateImportStatus';
import { useTranslation } from 'react-i18next';
import TemplateUploadErrorsModal from '@rd-web-markets/shared/dist/util/files/TemplateUploadErrorsModal';
const TechnicalTemplatesControls = _ref => {
  let {
    handleImportTechnicalTemplate,
    claimGroup,
    setClaimGroup,
    handleToaster
  } = _ref;
  const [loading, setLoading] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [technicalTemplateImportStatus, isTechnicalTemplatePending, changePendingStatus] = useTechnicalTemplateImportStatus(claimGroup, setClaimGroup);
  const hiddenFileInput = useRef(null);
  const [shouldDeleteExistingData, setShouldDeleteExistingData] = useState(false);
  const {
    t
  } = useTranslation();
  const handleClick = () => {
    hiddenFileInput.current.click();
  };
  const uploadCostTemplate = async e => {
    if (e.target.files[0].type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      handleToaster('Please upload excel file', 'warning');
    } else {
      await handleImportTechnicalTemplate(e, shouldDeleteExistingData);
      changePendingStatus();
    }
    hiddenFileInput.current.value = '';
  };
  const generateTechnicalTemplate = () => {
    setLoading(true);
    window.open(`/api/claim_groups/${claimGroup.id}/claim_export_technical_template`);
    setLoading(false);
  };
  const headers = [{
    text: 'Error'
  }];
  const rows = () => {
    return (technicalTemplateImportStatus.import_errors || []).map(error => ({
      columns: [error.message]
    }));
  };
  const modalBody = () => {
    if (!technicalTemplateImportStatus) {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    } else {
      return /*#__PURE__*/React.createElement(Table, {
        headers: headers,
        rows: rows(),
        showControls: false
      });
    }
  };
  const renderStatus = () => {
    switch (technicalTemplateImportStatus.import_status) {
      case 'never_imported':
        return 'Template was never imported';
      case 'pending':
        return 'Pending';
      case 'successfully_imported':
        return 'Template was imported successfully';
      case 'unsuccessfully_imported':
        return /*#__PURE__*/React.createElement("span", null, "There were errors importing the file.", /*#__PURE__*/React.createElement(Button, {
          style: {
            padding: 0,
            margin: 0
          },
          variant: "link",
          onClick: () => setModalShow(true)
        }, "You can check them here"));
      default:
        return '';
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TemplateUploadErrorsModal, {
    title: "Import Errors",
    body: modalBody(),
    show: modalShow,
    onHide: () => {
      setModalShow(false);
    }
  }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 6,
    className: "text-center"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 3,
      offset: 3
    }
  }, /*#__PURE__*/React.createElement(Button, {
    isImmutableUnderReview: true,
    variant: "info",
    iconPosition: "left",
    size: "md",
    icon: "upload_file",
    className: "mb-4",
    id: "upload-projects-template-button",
    loading: isTechnicalTemplatePending,
    onClick: handleClick
  }, "Upload Project(s) Template"), /*#__PURE__*/React.createElement("input", {
    style: {
      display: 'none'
    },
    type: "file",
    ref: hiddenFileInput,
    onChange: e => uploadCostTemplate(e)
  }), /*#__PURE__*/React.createElement("div", null, technicalTemplateImportStatus && renderStatus())), /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React.createElement(Form.Check, {
    checked: shouldDeleteExistingData,
    value: shouldDeleteExistingData,
    label: t('delete_existing_projects_load_new'),
    name: 'should-delete-existing-data',
    onChange: e => setShouldDeleteExistingData(e.target.checked)
  })))), /*#__PURE__*/React.createElement(Col, {
    md: 6,
    className: "text-center"
  }, /*#__PURE__*/React.createElement(Button, {
    isImmutableUnderReview: true,
    className: "mb-4",
    onClick: () => generateTechnicalTemplate(),
    size: "md",
    loading: loading,
    variant: "info",
    id: "download-projects-template-button",
    iconPosition: "left",
    icon: "download"
  }, "Download Project(s) Template"))));
};
export default TechnicalTemplatesControls;